import React from 'react'

const BlueClock = (props) => (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path fillRule="evenodd" clipRule="evenodd" d="M6 10.25a4.25 4.25 0 1 0 0-8.5 4.25 4.25 0 0 0 0 8.5zM6 11A5 5 0 1 0 6 1a5 5 0 0 0 0 10z" fill="#068AE2"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M6 2.625c.207 0 .375.168.375.375v2.845l1.64 1.64a.375.375 0 1 1-.53.53l-1.75-1.75A.375.375 0 0 1 5.625 6V3c0-.207.168-.375.375-.375z" fill="#068AE2"/>
    </svg>

    
)

export default BlueClock
